import React, { useEffect, useState } from 'react'
import Header from '../component/Header';
import Footer from '../component/Footer';
import axios from "../helper/axios";

export default function Terms() {
  const [allCms, setAllCms] = useState([]);
  const apiData = async () => {
    const res = await axios.post("/getcms");
    if (res.status === 200) {
      setAllCms(res?.data);
    } else {
      setAllCms()
    }
  }

  useEffect(() => {
    apiData();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0 });
  };
  useEffect(() => {
    scrollToTop();
  }, [])

  return (
    <>
      <Header />

      <div className="container mx-auto pt-[5.5rem] sm:pt-[6rem] md:pt-[7rem]">
        <div className="Cart mt-heading">
          <div className="container wishlist p-0-mobile">
            <div>
              <div className="CartItem fade-in-down">
                <div className="CartItem__content delivery">
                  {allCms?.length > 0 &&
                    allCms.map((dt, index) =>
                      dt.slugTitle === "term-conditions" ? (
                        <React.Fragment key={index}>
                          <h2 className="privacy-heading   mb-6 leading-snug" style={{ height: "auto" }}>
                            <strong>{dt.pageTitle}</strong>
                          </h2>
                          <div
                            className="text-base leading-relaxed"
                            dangerouslySetInnerHTML={{ __html: dt.pageContent }}
                          />
                        </React.Fragment>
                      ) : null
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>






      {/* <div className='container mx-auto pt-32'>
        <div className="Cart mt-heading">
          <div className="p-0-mobile container wishlist">
            <div className="">
              <div className="CartItem fade-in-down">

                {allCms?.length > 0 && allCms?.map((dt, index) => (
                  dt.slugTitle === "term-conditions" ? (
                    <div className="CartItem__content inner-pages delivery">
                      <h2 className='privacy-heading'><strong>{dt.pageTitle}</strong></h2>
                      <div
                        dangerouslySetInnerHTML={{ __html: dt.pageContent }}
                      />
                    </div>
                  ) : null
                ))}
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <Footer />
    </>
  )
}

